if (!customElements.get('pc-product-slider')) {
  class PCProductSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pc-product-slider__track');

      if (!this.track) return;

      this.pointerIsDown = false;
      this.dragging = false;
      this.suppressClick = false;
      this.pointerId = null;
      this.startX = 0;
      this.startScrollLeft = 0;

      this.handlePointerDown = (event) => this.startDrag(event);
      this.handlePointerMove = (event) => this.drag(event);
      this.handlePointerUp = (event) => this.stopDrag(event);
      this.handleClick = (event) => {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      };
      this.preventNativeDrag = (event) => event.preventDefault();

      this.track.addEventListener('pointerdown', this.handlePointerDown);
      this.track.addEventListener('click', this.handleClick, true);
      this.track.addEventListener('dragstart', this.preventNativeDrag);
      window.addEventListener('pointermove', this.handlePointerMove, { passive: false });
      window.addEventListener('pointerup', this.handlePointerUp);
      window.addEventListener('pointercancel', this.handlePointerUp);
    }

    disconnectedCallback() {
      this.track?.removeEventListener('pointerdown', this.handlePointerDown);
      this.track?.removeEventListener('click', this.handleClick, true);
      this.track?.removeEventListener('dragstart', this.preventNativeDrag);
      window.removeEventListener('pointermove', this.handlePointerMove);
      window.removeEventListener('pointerup', this.handlePointerUp);
      window.removeEventListener('pointercancel', this.handlePointerUp);
    }

    startDrag(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;

      this.pointerIsDown = true;
      this.dragging = false;
      this.suppressClick = false;
      this.pointerId = event.pointerId;
      this.startX = event.clientX;
      this.startScrollLeft = this.track.scrollLeft;
    }

    drag(event) {
      if (!this.pointerIsDown || event.pointerId !== this.pointerId) return;

      const distance = event.clientX - this.startX;
      if (!this.dragging && Math.abs(distance) <= 5) return;

      if (!this.dragging) {
        this.dragging = true;
        this.suppressClick = true;
        this.track.classList.add('is-dragging');
      }

      event.preventDefault();
      this.track.scrollLeft = this.startScrollLeft - distance;
    }

    stopDrag(event) {
      if (!this.pointerIsDown || event.pointerId !== this.pointerId) return;

      this.pointerIsDown = false;
      this.dragging = false;
      this.pointerId = null;
      this.track.classList.remove('is-dragging');

      window.setTimeout(() => {
        this.suppressClick = false;
      }, 0);
    }
  }

  customElements.define('pc-product-slider', PCProductSlider);
}
